import APIS from "../../constant/EndPoint";
import { useNavigate } from "react-router-dom";
import Card from "../Reusable/Card";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const UserProfile = (props: any) => {
  const { profile } = props;
  const navigate = useNavigate();

  const { mutateAsync } = usePostHook({
    queryKey: ["."],
    navigateURL: "",
  });
  return (
    <>
      <Card>
        <div className={tw``}>
          <table>
            <tbody>
              <tr>
                <td>Name</td>
                <td>:</td>
                <td>{profile?.name ?? profile?.full_name ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>:</td>
                <td>{profile?.user?.email ?? profile?.email ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Contact Number</td>
                <td>:</td>
                <td>{profile?.user?.mobile_number ?? "N/A"}</td>
              </tr>
            </tbody>
          </table>
          <div className={tw`w-full flex justify-between`}>
            <div className={tw`w-[150px] mt-3`}>
              <button
                type="button"
                className={tw`cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                onClick={() =>
                  navigate(
                    `/human-resource-management/employee/staffs/edit/${profile?.user?.id}`
                  )
                }
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default UserProfile;
